export enum EScreenSizes {
  smallMobile = 320,
  mobile = 468,
  tablet = 768,
  desktop = 1024,
  mediumDesktop = 1280,
  largeDesktop = 1440,
  hugeDesktop = 1666,
}
const screenSizes = {
  smallMobile: EScreenSizes.smallMobile,
  mobile: EScreenSizes.mobile,
  tablet: EScreenSizes.tablet,
  desktop: EScreenSizes.desktop,
  mediumDesktop: EScreenSizes.mediumDesktop,
  largeDesktop: EScreenSizes.largeDesktop,
  hugeDesktop: EScreenSizes.hugeDesktop,
};

export const { smallMobile, mobile, tablet, desktop, mediumDesktop, largeDesktop, hugeDesktop } = screenSizes;
